import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Get Gift Details
 */
const createGiftCardDetails = (
  value: number,
  senderDetails: {
    email: String
    name: String
  },
  recipient: {
    email: String
    name: String
  },
  giftMessage: string,
  deliveryMethod: 'email' | 'link',
  deliveryDate?: Date,
  isAnonymous = false,
  designType: 'default' | 'christmas' | 'valentine' = 'default'
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const tokenId = Cookies.get(AUTH_TOKEN_KEY)
      const URL = routes.GIFTING + '/gift-card'
      const config = {
        headers: {
          Authorization: `Bearer ${tokenId}`,
        },
      }
      const data = {
        value,
        senderDetails,
        recipient,
        giftMessage,
        deliveryMethod,
        deliveryDate,
        isAnonymous,
        designType,
      }

      AxiosClient.post(URL, data, config)
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    } catch (err) {
      reject(err)
    }
  })
}
export default createGiftCardDetails
